import { Header } from './Header.jsx';
import { Footer } from './Footer.jsx';
import { SkipLink } from '@components/a11y/SkipLink.jsx';
import { RouteAnnouncer } from '@components/a11y/RouteAnnouncer.jsx';
import { SubmitPaperFab } from '@components/SubmitPaperFab.jsx';

export function Layout({ children }) {
  return (
    <div className="relative min-h-screen flex flex-col">
      {/* Skip link must be the first focusable element in the DOM */}
      <SkipLink />

      {/* Decorative gradient mesh sitting behind everything */}
      <div aria-hidden="true" className="pointer-events-none fixed inset-0 -z-10 bg-mesh-light dark:bg-mesh-dark opacity-100" />
      {/* Subtle grain texture */}
      <div aria-hidden="true" className="pointer-events-none fixed inset-0 -z-10 bg-grain opacity-[0.035] dark:opacity-[0.06] mix-blend-overlay" />

      <Header />

      <main
        id="main"
        tabIndex={-1}
        className="flex-1 focus:outline-none"
      >
        {children}
      </main>

      <Footer />

      {/* Global "Submit Your Paper Now" floating button + guidelines popup */}
      <SubmitPaperFab />

      {/* Visually-hidden announcer for SPA route changes */}
      <RouteAnnouncer />
    </div>
  );
}
